module.exports = __webpack_public_path__ + "static/media/3.3b6fa3be.jpg";